module.exports = __webpack_public_path__ + "images/fbd67a9ddc99d13e0605bdca1e08d750-logo_white.png";